import {useClient} from "../../api/useClient";

export function useAccount() {
    const client = useClient();
    return client.useAccountWrapper().account;
}